/**
 * The API returns the recovery phrase exactly once (redeem, setup, rotate). We keep it on this
 * device so Settings can show it again (DESIGN assumption 2). Never sent anywhere else. It is
 * keyed by user id so whoever signs in next on a shared device never sees someone else's.
 */
const KEY = 'split.recoveryPhrase';

export function storeRecoveryPhrase(userId: string, phrase: string): void {
  try {
    localStorage.setItem(`${KEY}.${userId}`, phrase);
  } catch {
    // Storage unavailable: the user still saw it during onboarding.
  }
}

export function storedRecoveryPhrase(userId: string): string | null {
  try {
    return localStorage.getItem(`${KEY}.${userId}`);
  } catch {
    return null;
  }
}

/** Forgets every phrase kept on this device. */
export function clearRecoveryPhrase(): void {
  try {
    for (let i = localStorage.length - 1; i >= 0; i--) {
      const k = localStorage.key(i);
      if (k?.startsWith(`${KEY}.`)) localStorage.removeItem(k);
    }
  } catch {
    // ignore
  }
}
